import getConfig from 'next/config'

const { publicRuntimeConfig } = getConfig()
const STATIC_FILES_URL = publicRuntimeConfig.STATIC_FILES_URL || ''

export default STATIC_FILES_URL
